import { render, staticRenderFns } from "./Vod.vue?vue&type=template&id=4396f026&"
import script from "./Vod.vue?vue&type=script&lang=js&"
export * from "./Vod.vue?vue&type=script&lang=js&"
import style0 from "./Vod.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports